import { Skeleton } from "@mui/material"
import { styled } from "@mui/material/styles"

export const SkeletonX = styled(Skeleton)({
  background: "#f2f2f2",
  borderRadius: "4px",
  border: "0px solid #ebebeb",
  transform: "none"
})
